import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Button } from './Button'

// Controlled: the button shows the requested state while onChange's request is
// pending, then the parent's pressed prop again once it settles.
export function ToggleButton({
  pressed,
  onChange,
  children,
  iconOnly = false,
  pressedFill = true,
  ...props
}) {
  const [requested, setRequested] = useState(null)
  const shown = requested ?? pressed
  const settle = () => setRequested(null)
  const name = props['aria-label'] || children
  return (
    <Button
      {...props}
      data-pressed-fill={pressedFill ? undefined : 'none'}
      icon={props[shown ? 'data-pressed-icon' : 'data-unpressed-icon']}
      aria-pressed={shown}
      aria-label={name}
      data-tooltip={
        iconOnly ? props['data-tooltip'] || name : props['data-tooltip']
      }
      onSuccess={settle}
      onFailure={error => {
        settle()
        props.onFailure?.(error)
      }}
      onCancel={settle}
      onAction={() => {
        setRequested(!shown)
        return onChange(!shown)
      }}
    >
      {iconOnly
        ? undefined
        : props[shown ? 'data-pressed-label' : 'data-unpressed-label'] ||
          children}
    </Button>
  )
}

ToggleButton.propTypes = {
  pressed: PropTypes.bool.isRequired,
  // Receives the requested state and returns the request's promise.
  onChange: PropTypes.func.isRequired,
  onFailure: PropTypes.func,
  // The accessible name; an icon-only toggle also shows it as its tooltip.
  children: PropTypes.string.isRequired,
  // An icon button: the glyph alone, with no visible label.
  iconOnly: PropTypes.bool,
  // false: the glyph alone shows the state; a pressed icon toggle keeps no
  // resting brand-tint fill, only the tone's hover and press tints.
  pressedFill: PropTypes.bool,
  'data-pressed-icon': PropTypes.string.isRequired,
  'data-unpressed-icon': PropTypes.string.isRequired,
  'data-pressed-label': PropTypes.string,
  'data-unpressed-label': PropTypes.string,
}
